// extracted by mini-css-extract-plugin
export default {"modal":"elyiGWXqt3oTU4Fl6tz9","close":"twXn4r9B7tqJMlrcn4Ll","submit":"KH0IviIRoZxkltrWcb6n"};